import { useState } from "react";
import { server } from "../../server";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";

function AddBus() {
  const [formData, setFormData] = useState({
    generalInfo: {
      busNumber: "",
      vehicleNumber: "",
      numberOfSeats: "",
      chassisNumber: "",
      engineNumber: "",
      tasPaidDate: "",
      tasPaidExpiryDate: "",
      fitenessDate: "",
      fitnessRenewalDate: "",
      gprsStatus: "",
      pollutionControlDate: "",
      pollutionControlExpiryDate: "",
      cctvInstalled: "",
      ownerName: "",
    },
    insurance: {
      insuranceCompany: "",
      insurancePolicyNumber: "",
      insuranceAmount: "",
      insuranceDate: "",
      insuranceExpiryDate: "",
    },
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleGeneralInfoChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      generalInfo: {
        ...prevData.generalInfo,
        [name]: name === "numberOfSeats" ? Number(value) || 0 : value,
      },
    }));
  };

  const handleInsuranceChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      insurance: {
        ...prevData.insurance,
        [name]: name === "insuranceAmount" ? Number(value) || 0 : value,
      },
    }));
  };

  const countFilledFields = (obj) => {
    return String(
      Object.values(obj).filter((value) => value !== "").length
    ).padStart(2, "0");
  };

  const getTotalFields = (obj) => {
    return String(Object.keys(obj).length).padStart(2, "0");
  };
  const isCompleted = countFilledFields === getTotalFields;

  const handleSubmit = async (e) => {
    e.preventDefault();
    let newErrors = {};

    setLoading(true);

    try {
      const response = await axios.post(
        `${server}/addBusUsingMongoDb`,
        formData,
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("New Bus Added", { position: "top-right" });
      navigate("/bus-details");
      setFormData({
        generalInfo: {
          busNumber: "",
          vehicleNumber: "",
          numberOfSeats: "",
          registrationNumber: "",
          chassisNumber: "",
          engineNumber: "",
          tasPaidDate: "",
          tasPaidExpiryDate: "",
          fitenessDate: "",
          fitnessRenewalDate: "",
          gprsStatus: "",
          pollutionControlDate: "",
          pollutionControlExpiryDate: "",
          cctvInstalled: "",
          ownerName: "",
        },
        insurance: {
          insuranceCompany: "",
          insurancePolicyNumber: "",
          insuranceAmount: "",
          insuranceDate: "",
          insuranceExpiryDate: "",
        },
      });
    } catch (error) {
      toast.error("Please Try Again", { position: "top-right" });
    } finally {
      setLoading(false);
      return;
    }
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div className="">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-12">
                  <div class="m-3 mt-2 pt-1 d-flex justify-content-between">
                    <div class="d-flex align-items-center mt-2">
                      <span
                        onClick={() => window.history.back()}
                        class="back-button me-3 cursor-pointer"
                      >
                        <i className="bi bi-arrow-left fs-3"></i>
                      </span>
                      <nav aria-label="breadcrumb">
                        <h4 className="m-0 lh-sm">Add Bus</h4>
                        <ol class="breadcrumb pe-3 lh-sm">
                          <li class="breadcrumb-item">
                            <a href="#">Transport Management</a>
                          </li>
                          <li class="breadcrumb-item">
                            <a href="#">Bus Details</a>
                          </li>
                          <li
                            class="breadcrumb-item active"
                            aria-current="page"
                          >
                            Add Bus
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="container-fluid">
              <div className="row g-2">
                <div className="col-lg-8">
                  <form onSubmit={handleSubmit}>
                    <div class="px-5 py-3 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingOne">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-controls="collapseOne"
                            >
                              <span class="me-auto fs-5">
                                1. General Information{" "}
                                <span className="ms-3 text-secondary">
                                  ({countFilledFields(formData.generalInfo)}/
                                  {getTotalFields(formData.generalInfo)})
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span
                                  className={`badge me-5 px-3 ${
                                    countFilledFields(formData.generalInfo) ===
                                    getTotalFields(formData.generalInfo)
                                      ? "bg-success-soft"
                                      : "bg-danger-soft"
                                  }`}
                                >
                                  {countFilledFields(formData.generalInfo) ===
                                  getTotalFields(formData.generalInfo)
                                    ? "Completed"
                                    : "Required"}
                                </span>
                                <div class="form-check form-switch me-4">
                                  <input
                                    type="checkbox"
                                    class="form-check-input m-0"
                                    checked
                                  />
                                </div>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseOne"
                            class="collapse"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Bus No
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.generalInfo?.busNumber
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="busNumber"
                                  placeholder="Enter Bus No"
                                  value={formData.generalInfo?.busNumber}
                                  onChange={handleGeneralInfoChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Vehicle No
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.generalInfo?.vehicleNumber
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="vehicleNumber"
                                  placeholder="Enter Vehicle No"
                                  value={formData.generalInfo.vehicleNumber}
                                  onChange={handleGeneralInfoChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  No. Of Seats
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.generalInfo?.numberOfSeats
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="numberOfSeats"
                                  placeholder="Enter No. Of Seats"
                                  value={formData.generalInfo.numberOfSeats}
                                  onChange={handleGeneralInfoChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Chasis No
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.generalInfo?.chassisNumber
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="chassisNumber"
                                  placeholder="Enter Chasis No"
                                  value={formData.generalInfo.chassisNumber}
                                  onChange={handleGeneralInfoChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Engine No
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.generalInfo?.engineNumber
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="engineNumber"
                                  placeholder="Enter Engine No"
                                  value={formData.generalInfo.engineNumber}
                                  onChange={handleGeneralInfoChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Tax Paid Date
                                </label>
                                <input
                                  type="date"
                                  className={`form-control text-dark ${
                                    errors?.generalInfo?.tasPaidDate
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="tasPaidDate"
                                  placeholder="Enter Tax Paid Date"
                                  value={formData.generalInfo.tasPaidDate}
                                  onChange={handleGeneralInfoChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Tax Paid Expiry Date
                                </label>
                                <input
                                  type="date"
                                  className={`form-control text-dark ${
                                    errors?.generalInfo?.tasPaidExpiryDate
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="tasPaidExpiryDate"
                                  placeholder="Enter Tax Paid Expiry Date"
                                  value={formData.generalInfo.tasPaidExpiryDate}
                                  onChange={handleGeneralInfoChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Fitness Date
                                </label>
                                <input
                                  type="date"
                                  className={`form-control text-dark ${
                                    errors?.generalInfo?.fitenessDate
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="fitenessDate"
                                  placeholder="Enter Fitness Date"
                                  value={formData.generalInfo.fitenessDate}
                                  onChange={handleGeneralInfoChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Fitness Renewal Date
                                </label>
                                <input
                                  type="date"
                                  className={`form-control text-dark ${
                                    errors?.generalInfo?.fitnessRenewalDate
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="fitnessRenewalDate"
                                  placeholder="Enter Fitness Renewal Date"
                                  value={
                                    formData.generalInfo.fitnessRenewalDate
                                  }
                                  onChange={handleGeneralInfoChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  GPRS Status{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <Select
                                  name="gprsStatus"
                                  value={
                                    ["Installed", "Not Installed"]
                                      .map((status) => ({
                                        label: status,
                                        value: status,
                                      }))
                                      .find(
                                        (opt) =>
                                          opt.value ===
                                          formData.generalInfo.gprsStatus
                                      ) || null
                                  }
                                  onChange={(selected) =>
                                    handleGeneralInfoChange({
                                      target: {
                                        name: "gprsStatus",
                                        value: selected?.value || "",
                                      },
                                    })
                                  }
                                  options={["Installed", "Not Installed"].map(
                                    (status) => ({
                                      label: status,
                                      value: status,
                                    })
                                  )}
                                  placeholder="Select GPRS Status"
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Pollution Control Date{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="date"
                                  className={`form-control text-dark ${
                                    errors?.generalInfo?.pollutionControlDate
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="pollutionControlDate"
                                  placeholder="Enetr Pollution Control Date"
                                  value={
                                    formData.generalInfo.pollutionControlDate
                                  }
                                  onChange={handleGeneralInfoChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Pollution Control Expiry Date{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="date"
                                  className={`form-control text-dark ${
                                    errors?.generalInfo
                                      ?.pollutionControlExpiryDate
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  placeholder="Enter Pollution Control Expiry Date"
                                  name="pollutionControlExpiryDate"
                                  value={
                                    formData.generalInfo
                                      .pollutionControlExpiryDate
                                  }
                                  onChange={handleGeneralInfoChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  CCTV Installed{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <Select
                                  name="cctvInstalled"
                                  value={
                                    ["Yes", "No"]
                                      .map((opt) => ({
                                        label: opt,
                                        value: opt,
                                      }))
                                      .find(
                                        (opt) =>
                                          opt.value ===
                                          formData.generalInfo.cctvInstalled
                                      ) || null
                                  }
                                  onChange={(selected) =>
                                    handleGeneralInfoChange({
                                      target: {
                                        name: "cctvInstalled",
                                        value: selected?.value || "",
                                      },
                                    })
                                  }
                                  options={["Yes", "No"].map((opt) => ({
                                    label: opt,
                                    value: opt,
                                  }))}
                                  placeholder="Select CCTV Installed"
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Owner Name{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.generalInfo?.ownerName
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="ownerName"
                                  placeholder="Enter Owner Name"
                                  value={formData.generalInfo.ownerName}
                                  onChange={handleGeneralInfoChange}
                                  required
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingTwo">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseTwo"
                              aria-controls="collapseTwo"
                            >
                              <span class="me-auto fs-5">
                                2. Insurance Details{" "}
                                <span className="ms-3 text-secondary">
                                  ({countFilledFields(formData.insurance)}/
                                  {getTotalFields(formData.insurance)})
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span
                                  className={`badge me-5 px-3 ${
                                    countFilledFields(formData.insurance) ===
                                    getTotalFields(formData.insurance)
                                      ? "bg-success-soft"
                                      : "bg-danger-soft"
                                  }`}
                                >
                                  {countFilledFields(formData.insurance) ===
                                  getTotalFields(formData.insurance)
                                    ? "Completed"
                                    : "Required"}
                                </span>
                                <div class="form-check form-switch me-4">
                                  <input
                                    type="checkbox"
                                    class="form-check-input m-0"
                                    checked
                                  />
                                </div>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseTwo"
                            class="collapse"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Insurance Company
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.insurance?.insuranceCompany
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="insuranceCompany"
                                  placeholder="Enter Insurance Company Name"
                                  value={formData.insurance.insuranceCompany}
                                  onChange={handleInsuranceChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Policy Number
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.insurance?.insurancePolicyNumber
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="insurancePolicyNumber"
                                  placeholder="Enter Policy Number"
                                  value={
                                    formData.insurance.insurancePolicyNumber
                                  }
                                  onChange={handleInsuranceChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Insurance Amount
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.insurance?.insuranceAmount
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="insuranceAmount"
                                  placeholder="Enter Insurance Amount"
                                  value={formData.insurance.insuranceAmount}
                                  onChange={handleInsuranceChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Insurance Date
                                </label>
                                <input
                                  type="date"
                                  className={`form-control text-dark ${
                                    errors?.insurance?.insuranceDate
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="insuranceDate"
                                  placeholder="Enter Insurance Date"
                                  value={formData.insurance.insuranceDate}
                                  onChange={handleInsuranceChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Insurance Expiry Date
                                </label>
                                <input
                                  type="date"
                                  className={`form-control text-dark ${
                                    errors?.insurance?.insuranceExpiryDate
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="insuranceExpiryDate"
                                  placeholder="Enter Insurance Expiry Date"
                                  value={formData.insurance.insuranceExpiryDate}
                                  onChange={handleInsuranceChange}
                                  required
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="my-3 d-flex float-end me-5">
                      <button type="submit" class="btn btn-success mt-2 px-6">
                        {loading ? (
                          <div
                            class="spinner-border spinner-border-sm"
                            role="status"
                          ></div>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
                <div className="col-lg-4">
                  <div class="p-5 bg-white rounded-4 sticky-top top-10 z-1">
                    <div className="d-flex flex-column align-items-center">
                      <div>
                        <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative me-2">
                          <img
                            src="/assets/images/bus.png"
                            className="w-100 h-100 object-fit-cover position-absolute rounded-3"
                            alt="Bus"
                          />
                        </div>
                        <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative">
                          <img
                            src="https://cdn-icons-png.flaticon.com/512/14021/14021384.png"
                            className="w-100 position-absolute p-2 rounded-4"
                            alt="QR"
                          />
                        </div>
                      </div>
                      <div className="mt-3 text-center">
                        <p className="m-0">
                          Bus No. {formData.generalInfo?.busNumber}
                        </p>
                        <h3 class="m-0 fs-4 lh-sm">
                          {formData.generalInfo.vehicleNumber || "Vehicle No"}
                        </h3>
                        <p className="m-0 text-dark mt-2">
                          {formData.generalInfo.ownerName || "Owner Name"}
                        </p>
                        <p className="mt-2 mb-0 text-danger lh-sm">
                          {formData.generalInfo.numberOfSeats || "Number Of"} Seats
                        </p>
                        <p className="mt-2 mb-0 text-danger lh-sm">
                          {formData.generalInfo.gprsStatus || "GPRS Status"}
                          <br />
                          {formData.generalInfo.cctvInstalled || "CCTV Status"}
                        </p>

                        <p className="m-0 lh-sm mt-4 text-capitalize">
                          {formData.insurance.insuranceCompany ||
                            "Insurance Company"}
                          <br />
                          {formData.insurance.insurancePolicyNumber ||
                            "Policy Number"}
                          <br />
                          {formData.insurance.insuranceAmount ||
                            "Insurance Amount"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default AddBus;
